import { sendGATapEvent } from './GATracker'

export const inAppURI = uri => 'sotetsu-app://open-uri?uri=' + uri

export const openURIInApp = (uri, gaCategory = null, gaLabel = null) => {
  if (gaCategory && gaLabel) {
    sendGATapEvent(gaCategory, gaLabel)
  }
  location.href = inAppURI(uri)
}

export const launchExtAppInApp = (
  string,
  gaCategory = null,
  gaLabel = null
) => {
  if (gaCategory && gaLabel) {
    sendGATapEvent(gaCategory, gaLabel)
  }
  location.href = `sotetsu-app://launch-ext-app?${string}`
}

export const callNavigationInApp = query => {
  const url = 'sotetsu-app://navigation?' + query
  location.href = url
}

export const openOutInApp = (query) => {
  if (!query) {
    return false
  }
  const url = 'sotetsu-app://out/' + query
  location.href = url
}

export const compareVersions = (v1, v2) => {
  const p1 = v1.split('.').map(Number)
  const p2 = v2.split('.').map(Number)
  for (let i = 0; i < 3; i++) {
    if ((p1[i] || 0) > (p2[i] || 0)) return 1
    if ((p1[i] || 0) < (p2[i] || 0)) return -1
  }
  return 0
}

// アプリ内ページへのナビゲーション（event.preventDefault()を含む）
// appVersion が 1.6.0 以上の場合はカスタムスキームで遷移、それ未満は通常のリンク動作に任せる
export const navigateToInApp = (event, path, appVersion, query = '') => {
  if (appVersion && compareVersions(appVersion, '1.6.0') >= 0) {
    event.preventDefault()
    const baseUrl = process.env.WWW_BASE_URL
    const fullQuery = `url=${encodeURIComponent(baseUrl + path)}${query}`
    callNavigationInApp(fullQuery)
  }
}
